var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.t(interpolate( gettext("Вы уже авторизованы как %(openTag)s%(accountName)s%(closeTag)s."), {'openTag': '<span class="b-bold js-account-name">', 'accountName': t.d("accountName",c,p,1)||"",'closeTag': '</span>'} , true)));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{{ ___0___ }}}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/already_authorized.html
// module id = 180
// module chunks = 4